module.exports = __webpack_public_path__ + "09dfdcd93ab51f3f15dcdf53120d5728.fbx";